import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Recent-project card placeholder, web shape — mirrors the real
 * `ProjectCard`'s bordered card shell: icon + title row, then a team chip and
 * an owner chip side-by-side in one row (each a single rect standing in for
 * that chip's icon/avatar + name together, not split into separate pieces).
 * Mirrors `ComposedProjectCard` in `stories/atoms/Skeleton.stories.tsx`.
 *
 * The native counterpart in `ProjectCardSkeleton.tsx` mirrors
 * `RecentProjectCard` instead: a fixed 156-high card that stacks the two
 * chips vertically and takes its width from the parent (TA-10386).
 */
export const ProjectCardSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'project-card-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      width={220}
      borderWidth={1}
      borderColor='grey02'
      borderRadius='xs'
      padding='m'>
      <Box
        flexDirection='row'
        alignItems='center'
        style={{ gap: theme.spacing.xs }}>
        <Skeleton variant='rect' width={32} height={32} borderRadius='xxs' />
        <Box flex={1}>
          <Skeleton variant='text' width='70%' />
        </Box>
      </Box>
      <Box flexDirection='row' marginTop='l' style={{ gap: theme.spacing.xs }}>
        <Box flex={1}>
          <Skeleton
            variant='rect'
            width='100%'
            height={24}
            borderRadius='xxs'
          />
        </Box>
        <Box flex={1}>
          <Skeleton
            variant='rect'
            width='100%'
            height={24}
            borderRadius='xxs'
          />
        </Box>
      </Box>
    </Box>
  );
};
